// extracted by mini-css-extract-plugin
export default {"onboardingPopupContainer":"OnboardingPopup_onboardingPopupContainer__2mSUg","onboardingPopupContainer--tourActive":"OnboardingPopup_onboardingPopupContainer--tourActive__GHJLo"};